<template>
  <oxd-dialog
    :style="{width: '90%', maxWidth: '550px'}"
    @update:show="onCancel"
  >
    <div class="gsl-hrm-modal-header">
      <oxd-text type="card-title">
        {{ $t('leave.leave_action_log') }}
      </oxd-text>
    </div>
    <oxd-divider />
    <div class="gsl-hrm-vertical-padding">
      <oxd-text
        v-for="(entry, index) in data"
        :key="index"
        tag="p"
        class="gsl-hrm-log-text"
      >
        <span :class="['indicator', getStatusClass(entry.status)]"></span>
        <b :class="getStatusClass(entry.status)">
          {{ getStatusLabel(entry.status) }}
        </b>
        by <b>{{ entry.name }}</b> on {{ formatDate(entry.createdAt) }}
      </oxd-text>
    </div>
  </oxd-dialog>
</template>
<script>
import {OxdDialog} from '@ohrm/oxd';
import useLocale from '@/core/util/composable/useLocale';
import useDateFormat from '@/core/util/composable/useDateFormat';
import {formatDate} from '@/core/util/helper/datefns';
import {parseISO} from 'date-fns';
export default {
  name: 'LeaveActionLogModal',
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  setup() {
    const {locale} = useLocale();
    const {jsDateFormat, jsTimeFormat} = useDateFormat();
    return {
      locale,
      jsDateFormat,
      jsTimeFormat,
    };
  },
  methods: {
    onCancel() {
      this.$emit('close');
    },
    getStatusLabel(status) {
      switch (status) {
        case 2:
          return 'Approved';
        case -2:
          return 'Assigned';
        case 0:
          return 'Cancelled';
        case -1:
          return 'Rejected';
        case 1:
          return 'Applied';
        case 4:
          return 'Cancelled (Weekend)';
        default:
          return 'Unknown';
      }
    },
    formatDate(dateString) {
      const {date} = dateString;
      const utcString = date.replace(' ', 'T').replace(/\.\d+$/, '') + 'Z';
      const utcDate = parseISO(utcString);
      return utcDate
        ? formatDate(utcDate, `${this.jsDateFormat} ${this.jsTimeFormat}`, {
            locale: this.locale,
          })
        : null;
    },
    getStatusClass(status) {
      switch (status) {
        case 2:
          return 'status-approved';
        case -2:
          return 'status-approved';
        case 0:
          return 'status-cancelled';
        case 1:
          return 'status-pending';
        case -1:
          return 'status-rejected';
        case 4:
          return 'status-weekend';
        default:
          return 'status-unknown';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-log-text {
  font-size: 0.85rem;
  font-family: $oxd-font-family;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.status-approved {
  color: green;
}

.status-cancelled {
  color: #ff7f08;
}
.status-pending {
  color: #f7ac23;
}

.status-rejected {
  color: red;
}
.status-weekend {
  color: #146da0;
}
.status-unknown {
  color: gray;
}
.indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 0.5rem;

  &.status-approved {
    background-color: #8ace79;
    border: 1px solid #070707;
  }
  &.status-cancelled {
    background-color: #ff7f08;
    border: 1px solid #070707;
  }
  &.status-pending {
    background-color: #f7ac23;
    border: 1px solid #070707;
  }

  &.status-rejected {
    background-color: #cf6060;
    border: 1px solid #070707;
  }
  &.status-weekend {
    background-color: #146da0;
    border: 1px solid #070707;
  }
  &.status-unknown {
    background-color: gray;
    border: 1px solid #070707;
  }
}
</style>
